import React from 'react';

import { FormLabel, Stack, TextField } from '@mui/material';

interface Props {
  label: string;
  value: string;
  onChange: (value: string) => void;
}

export default function PackageTextField({ label, value, onChange }: Props) {
  return (
    <Stack spacing={1}>
      <FormLabel>{label}</FormLabel>
      <TextField value={value} size="small" fullWidth onChange={(event) => onChange(event.target.value)} />
    </Stack>
  );
}
